// src/utils/dateUtils.js

// Converts YYYY-MM-DD to DD-MM-YYYY
export function formatDateToDD_MM_YYYY(dateString) {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
}

// Converts DD-MM-YYYY to YYYY-MM-DD
export function formatDateToYYYY_MM_DD(dateString) {
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
}

// Converts month number (1-12) to month name
export function getMonthName(monthNumber) {
    if (!monthNumber || monthNumber === "0") return "Current Month";
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    return months[parseInt(monthNumber, 10) - 1] || "Current Month";
}

export function formatDateToDD_MM_YYYY_HH_MM_SS(dateTimeString) {
    if (!dateTimeString) return '';

    if (dateTimeString.includes('T')) {
        const [datePart, timePart] = dateTimeString.split('T');
        const [year, month, day] = datePart.split('-');
        const timeWithoutMs = timePart.split('.')[0];
        return `${day}-${month}-${year} ${timeWithoutMs}`;
    }

    if (dateTimeString.includes(' ')) {
        const [datePart, timePart] = dateTimeString.split(' ');
        const [year, month, day] = datePart.split('-');
        return `${day}-${month}-${year} ${timePart}`;
    }

    const [year, month, day] = dateTimeString.split('-');
    return `${day}-${month}-${year} 00:00:00`;
}
